var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select',{attrs:{"title":"ТИП ОТЧЕТА:","form-group":"","form-group-margin-bottom":"","options":{ days: 'ПО ДНЯМ', updates: 'ПО АПДЕЙТАМ' }},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})
}
var staticRenderFns = []

export { render, staticRenderFns }